export class PartialSearchRequest {
    AuctionEarliestDate:Date;
    AuctionLatestDate:Date;
    PickupCity:string;
    PickupPostalCode:string;
    VehicleMake:string;
    VehicleModel:string;
    VehicleYear:string;
}


// WEBPACK FOOTER //
// ./src/app/VIewModels/TowLocateViewModels/PartialSearchRequest.ts